import { ApiConfig } from "../../../Api/Api";

export const getStandardDataApi = async () => {
  return await ApiConfig.get(`api/standard`);
};
